import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EjemploDto } from '../../../dto/justino/ejemplo.dto';

@Component({
  selector: 'app-ejemplo',
  templateUrl: './ejemplo.component.html',
  styleUrl: './ejemplo.component.scss',
})
export class EjemploComponent {
  @Input() ejemplo!: EjemploDto;
  @Input() nivel: number = 0;
  @Input() isReadOnly: boolean = false;

  @Output() actualizar = new EventEmitter<EjemploDto>();
  @Output() eliminar = new EventEmitter<EjemploDto>();

  onActualizar() {
    // Acción de actualizar
    console.log('Actualizar:', this.ejemplo);
    this.actualizar.emit(this.ejemplo);
  }

  onEliminar() {
    // Acción de eliminar
    console.log('Eliminar:', this.ejemplo);
    this.eliminar.emit(this.ejemplo);
  }
}
